import React, {useState, useEffect} from 'react';
import {useLocation} from "react-router-dom";
import {BrowserRouter as Router, Routes, Route, Navigate} from 'react-router-dom';
import ViewerContainer from './components/PdfViewer/ViewerContainer/ViewerContainer';
import LoginPage from './components/Login/LoginPage';
import RegisterPage from './components/Register/RegisterPage';
import AdminPage from './components/Admin/AdminPage';
import HomePage from './components/Home/HomePage';
import CreateToolPage from './components/CreateTool/CreateToolPage';
import ToolUploadPage from './components/UseTool/ToolUploadPage';
import ToolResultsPage from './components/UseTool/ToolResultsPage';
import ToolHistoryPage from "./components/Home/ToolHistoryPage";
import {startSessionKeepAlive} from './sessionKeepAlive';
import LandingPage, {ContactPage, AcademyPage} from './components/Landing/LandingPage';
import {AcademyWatchRoute} from './components/Landing/LandingPage';
import ErrorBoundary from './components/ErrorBoundary';
import ErrorPage from './components/ErrorPage';

function ScrollToHashElement() {
    const {hash} = useLocation();

    useEffect(() => {
        if (hash) {
            const element = document.getElementById(hash.replace("#", ""));
            if (element) {
                element.scrollIntoView({behavior: "smooth"});
            }
        }
    }, [hash]);

    return null;
}

function App() {
    const [token, setToken] = useState(localStorage.getItem('token'));

    useEffect(() => {
        let stop;
        if (token) {
            stop = startSessionKeepAlive();
        }
        return () => stop && stop();
    }, [token]);

    // Listen to localStorage changes (e.g., after login or logout)
    useEffect(() => {
        const handleStorageChange = () => {
            setToken(localStorage.getItem('token'));
        };
        window.addEventListener('storage', handleStorageChange);
        return () => {
            window.removeEventListener('storage', handleStorageChange);
        };
    }, []);

    return (
        <Router>
            <ScrollToHashElement/>
            <ErrorBoundary>
                <Routes>
                    <Route path="/" element={<LandingPage/>}/>
                    <Route path="/contact" element={<ContactPage/>}/>
                    <Route path="/login" element={<LoginPage setToken={setToken}/>}/>
                    <Route path="/admin" element={token ? <AdminPage/> : <Navigate to="/"/>}/>
                    <Route path="/home" element={token ? <HomePage/> : <Navigate to="/"/>}/>
                    <Route path="/viewer" element={token ? <ViewerContainer/> : <Navigate to="/"/>}/>
                    <Route path="/create-tool" element={<CreateToolPage/>}/>
                    <Route path="/tool/:toolId/upload" element={<ToolUploadPage/>}/>
                    <Route path="/tool-results" element={<ToolResultsPage/>}/>
                    <Route path="/tool/:toolId/history" element={<ToolHistoryPage/>}/>
                    <Route path="/academy" element={<AcademyPage/>}/>
                    <Route path="/academy/watch/:id" element={<AcademyWatchRoute/>}/>
                    {/* Error & 404 routes */}
                    <Route path="/error" element={<ErrorPage/>}/>
                    <Route path="*" element={<ErrorPage/>}/>
                </Routes>
            </ErrorBoundary>
        </Router>
    );
}

export default App;
